import { render } from "./index.vue?vue&type=template&id=1fc16191&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1fc16191&lang=less&scoped=true"

import exportComponent from "/Users/chenli/Documents/buzzbuzz/第九工场/my-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc16191"]])

export default __exports__